// import { useQuery } from 'react-query';

// import { request } from 'utils';

export const useCensor = () => {
  // let { data: isMainland, isFetched, isError } = useQuery('censor', () =>
  //   request.get<boolean>('/user/is_mainland_ip', undefined, {
  //     timeout: Infinity,
  //   })
  // );

  // censored
  return [false, true, false] as const;
};
